import React from 'react';
import PropTypes from 'prop-types';
import { ListGroupItem } from 'reactstrap';
import { useQueryParam } from '~/utils';

import ServiceReferralEmailModal from '~/components/Patient/Identity/ServiceReferralEmail/Modal';

const ServiceReferralEmailButton = ({
  patientUid,
}) => {
  const [isModalOpen, setIsModalOpen] = useQueryParam('ServiceReferralEmail');
  const toggleIsModalOpen = () => setIsModalOpen(previous => !previous || undefined);

  return (
    <>
      <ListGroupItem
        onClick={toggleIsModalOpen}
        className="d-flex align-items-center border-dark side-nav-item border-top"
      >
        Service Referral Email
      </ListGroupItem>

      <ServiceReferralEmailModal
        isOpen={isModalOpen}
        toggleIsOpen={toggleIsModalOpen}
        patientUid={patientUid}
      />
    </>
  );
};

ServiceReferralEmailButton.propTypes = {
  patientUid: PropTypes.string.isRequired,
};

export default ServiceReferralEmailButton;
